<template>
  <div class="footer">
    <div class="container">
      Copyright © 千農科技有限公司. {{thisYear}}.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    thisYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  background-color: #333;
  text-align: center;
  color: rgb(102, 102, 102);
  padding: 10px;
  font-size: 0.8rem;
}
</style>
